/* eslint-disable */

(function( $, window, document, undefined ) {

    class BRValidate {

        constructor( el, options = {} ) {
            this.el = el;
            this.errors = {};

            this.options = $.extend({}, {
                errorBlockClass: 'has-error',
                inputErrorClass: 'error-block',
                rules: {
                    required: {
                        message: function( label ) {
                            return `${label} is required`;
                        }
                    },
                    email: {
                        pattern: /^(([a-zA-Z0-9_.\+-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+)?$/,
                        // pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        message: function( label ) {
                            return `${label} is not a valid email address`;
                        }
                    },
                    number: {
                        pattern: /^\d+$/,
                        message: function( label ) {
                            return `${label} is invalid`
                        }
                    }
                }
            }, options );

            this.el.noValidate = true;

            this._initSubmitEvent();
        }

        _initSubmitEvent() {

            $(this.el).on('submit', e => {
                e.preventDefault();
                e.stopImmediatePropagation();

                this._clearErrors();
                this._validate();
            });

        }

        getFormInputs() {
            return [...this.el.querySelectorAll('input,select,textarea')].map( input => {

                const label = input.hasAttribute('data-label') ? input.getAttribute('data-label') : $('[for="'+input.id+'"]').text(),
                      isRequired = input.hasAttribute('required'),
                      requiredError = (() => {
                          if( input.hasAttribute( 'data-required-error' ) ) {
                              return input.getAttribute( 'data-required-error' );
                          } else {
                              return this.options.rules['required'].message(label);
                          }
                      })(),
                      validateAs = input.hasAttribute( 'data-validate-as' ) && this.options.rules.hasOwnProperty( input.getAttribute( 'data-validate-as' ) ) ? input.getAttribute( 'data-validate-as' ) : false,
                      validateAsError = (() => {
                          if( input.hasAttribute( 'data-validate-as-error' ) ) {
                              return input.getAttribute( 'data-validate-as-error' );
                          } else {
                              if( validateAs ) {
                                  if( validateAs == 'email' ) {
                                      return this.options.rules[validateAs].message(input.value);
                                  } else {
                                      return this.options.rules[validateAs].message(label);
                                  }
                              } else {
                                  return null;
                              }
                          }
                      })();

                return {
                    id: input.id,
                    name: input.name,
                    value: input.value,
                    isRequired,
                    requiredError,
                    validateAs,
                    validateAsError
                }
            });
        }

        _validate() {
            this.getFormInputs().forEach( input => {
                this._validateInput( input );
            });

            if( this.errors.length > 0 ) {
                this.errors.forEach(err => {
                    let $input = $(`[name="${err.name}"]`),
                        $form_group = $input.closest('.form__group'),
                        errBlock = `<p class="${this.options.inputErrorClass}">${err.error}</p>`;

                    $form_group.addClass(this.options.errorBlockClass);
                    $form_group.append(errBlock);
                });
            } else {
                this.el.submit();
            }
        }

        _validateInput( input ) {

            let isError = false;

            if( input.isRequired ) {
                const nameSelector = `[name="${input.name}"]`;

                if(
                    ( $( nameSelector ).is(':checkbox') && !$( nameSelector )[0].checked ) ||
                    ( input.value == null || input.value === '' )
                ) {
                    this.errors.push({
                        id: input.id,
                        name: input.name,
                        errorType: 'required',
                        error: input.requiredError
                    });

                    isError = true;
                }
            }

            if( !isError && input.validateAs ) {
                const rule = this.options.rules[input.validateAs];

                if( !rule.pattern.test( input.value ) ) {
                    this.errors.push({
                        name: input.name,
                        errorType: 'invalid',
                        error: input.validateAsError
                    });
                }
            }
        }

        _clearErrors() {
            this.errors = [];
            $(this.el).find(`.${this.options.errorBlockClass}`).removeClass(this.options.errorBlockClass);
            $(this.el).find(`.${this.options.inputErrorClass}`).remove();
        }

    }

    $.fn.brValidate = function( options ) {
        this.each(function() {
            new BRValidate( this, options );
        });
    };

    $(document).ready(function() {
        $('[data-br-validate]').brValidate();
    });

})( jQuery, window, document );